import { gauge_children, home_gauge_children } from "./menus/index"
import { getOptDes } from "./menus/optDes"
const cxGauge = {
  name: "cxGauge",
  desc: "",
  render: () => import("./render/index.vue"),
  optDes: getOptDes,
  enable: true,
  menus: {
    bigScreen: [
      {
        name: "仪表盘",
        children: gauge_children,
        type: "gaugeComponent",
        group: "chart",
        sort: 90
      }
    ],
    app: [
      {
        name: "仪表盘",
        children: home_gauge_children,
        type: "gaugeComponent",
        group: "chart",
        sort: 102,
        enable(params) {
          // 暂时屏蔽
          return false
        }
      }
    ],
    portal: [
      {
        name: "仪表盘",
        children: home_gauge_children,
        type: "gaugeComponent",
        group: "chart",
        sort: 102,
        enable(params) {
          // 暂时屏蔽
          return false
        }
      }
    ]
  },
  toolbars: [
    {
      name: "cxGauge",
      label: "仪表盘",
      comp: {
        gaugeComponentData: () => import("./toolbars/gauge-options-data.vue"),
        gaugeComponentSetting: () => import("./toolbars/gauge-options-setting.vue"),
        gaugeComponentStyle: () => import("./toolbars/gauge-options-style.vue")
      }
    }
  ]
}

export default cxGauge
